import wxApi from '@/common/wx/config.js'
import http from '@/request/index'
class BetterweWxApi {
  constructor() {
    this.isWx = false
    this.isSign = false
    this.wxFriendOptions = null
    this.wxCircleOptions = null
    this.setDefaultShareOptions()
    this.isWx = this.isWeixn()
  }
  //设置默认分享参数
  setDefaultShareOptions() {
    this.wxFriendOptions = {
      title: document.title, // 分享标题
      desc: 'betterWE星球', // 分享描述
      link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png' // 分享图标
    }
    this.wxCircleOptions = {
      title: document.title, // 分享标题
      link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png' // 分享图标
    }
  }
  //重新进行微信jdk配置
  reConfig() {
    this.setDefaultShareOptions()
    this.config()
  }
  isWeixn() {
    let ua = navigator.userAgent.toLowerCase()
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true
    } else {
      return false
    }
  }
  config() {
    if (!this.isWx) {
      return
    }
    http
      .getWxConfig()
      .then((res) => {
        res = res.data
        let data = res.data
        if (res.code == 200) {
          document.addEventListener('WeixinOpenTagsError', function (e) {
            console.error(e.detail.errMsg) // 无法使用开放标签的错误原因，需回退兼容。仅无法使用开放标签，JS-SDK其他功能不受影响
          })
          wxApi.config(
            data,
            [
              'onMenuShareTimeline',
              'wx-open-launch-app',
              'updateAppMessageShareData',
              'updateTimelineShareData',
              'wx-open-launch-weapp'
            ],
            ['wx-open-launch-app', 'wx-open-launch-weapp']
          )
          wx.error(function (res) {
            // config信息验证失败会执行 error 函数，如签名过期导致验证失败，具体错误信息可以打开 config 的debug模式查看，也可以在返回的 res 参数中查看，对于 SPA 可以在这里更新签名
          })
          wx.ready(() => {
            this.isSign = true
            wx.updateAppMessageShareData({
              title: this.wxFriendOptions.title || document.title, // 分享标题
              desc: this.wxFriendOptions.desc || 'betterWE星球', // 分享描述
              link: this.wxFriendOptions.link || location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl:
                this.wxFriendOptions.imgUrl ||
                'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png', // 分享图标
              success: function () {
                // 设置成功
              }
            })
            wx.updateTimelineShareData({
              title: this.wxCircleOptions.title || document.title, // 分享标题
              link: this.wxCircleOptions.link || location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl:
                this.wxCircleOptions.imgUrl ||
                'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e93143f47e6418437ba209310fb2f306.png', // 分享图标
              success: function () {
                // 设置成功
              }
            })
          })
        }
      })
      .catch((err) => {})
  }
  //分享好友
  setShareData(friendOptions, circleOptions) {
    this.wxFriendOptions = friendOptions
    this.wxCircleOptions = circleOptions
    this.config()
  }
}
export default BetterweWxApi
